module.exports = {
  EUR: {
    en: "Euro",
    es: "Euro",
  },
  USD: {
    en: "United States dollar",
    es: "Dólar Estadounidense",
  },
  GBP: {
    en: "Pound sterling",
    es: "Libra Esterlina",
  },
  AED: {
    en: "United Arab Emirates Dirham",
    es: "Dírham de los Emiratos Árabes Unidos",
  },
  AUD: {
    en: "Australian dollar",
    es: "Dólar Australiano",
  },
  ARS: {
    en: "Argentine peso",
    es: "Peso Argentino",
  },
  BOB: {
    en: "Bolivian boliviano",
    es: "Bolívar Boliviano",
  },
  BGN: {
    en: "Bulgarian lev",
    es: "Leva Búlgara",
  },
  BHD: {
    en: "Bahraini dinar",
    es: "Dinar Bahreiní",
  },
  BRL: {
    en: "Brazilian real",
    es: "Real Brasileño",
  },
  CAD: {
    en: "Canadian dollar",
    es: "Dólar Canadiense",
  },
  CHF: {
    en: "Swiss franc",
    es: "Franco Suizo",
  },
  CRC: {
    en: "Costa Rican colon",
    es: "Colón Costaricense",
  },
  CNY: {
    en: "Chinese Yuan Renminbi",
    es: "Yuan Renminbi Chino",
  },
  CLF: {
    en: "Chilean Unit of Account (UF)",
    es: "Unidad de Fomento Chilena",
  },
  CLP: {
    en: "Chilean peso",
    es: "Peso Chileno",
  },
  COP: {
    en: "Colombian peso",
    es: "Peso Colombiano",
  },
  CZK: {
    en: "Czech koruna",
    es: "Corona Checa",
  },
  DKK: {
    en: "Danish krone",
    es: "Corona Danesa",
  },
  EGP: {
    en: "Egyptian pound",
    es: "Libra Egipcia",
  },
  GTQ: {
    en: "Guatemalan quetzal",
    es: "Quetzal Guatemalteco",
  },
  GYD: {
    en: "Guyanese dollar",
    es: "Dólar Guayanés",
  },
  HNL: {
    en: "Honduran lempira",
    es: "Lempira Hondureña",
  },
  HKD: {
    en: "Hong Kong dollar",
    es: "Dólar de Hong Kong",
  },
  HRK: {
    en: "Croatian kuna",
    es: "Kuna Croata",
  },
  HUF: {
    en: "Hungarian forint",
    es: "Florín Húngaro",
  },
  IDR: {
    en: "Indonesian rupiah",
    es: "Rupia Indonesia",
  },
  ILS: {
    en: "Israeli new shekel",
    es: "Shequel Israelí",
  },
  INR: {
    en: "Indian rupee",
    es: "Rupia India",
  },
  JPY: {
    en: "Japanese yen",
    es: "Yen Japonés",
  },
  KRW: {
    en: "South Korean won",
    es: "Won Surcoreano",
  },
  MAD: {
    en: "Moroccan Dirham",
    es: "Dirham Marroquí",
  },
  MUR: {
    en: "Mauritian Rupee",
    es: "Rupia Mauriciana",
  },
  MXN: {
    en: "Mexican peso",
    es: "Peso Mexicano",
  },
  MYR: {
    en: "Malaysian ringgit",
    es: "Ringgit Malasio",
  },
  NGN: {
    en: "Nigerian naira",
    es: "Naira Nigeriana",
  },
  NIO: {
    en: "Nicaraguan cordoba",
    es: "Córdoba Nicaragüense",
  },
  NOK: {
    en: "Norwegian krone",
    es: "Corona Noruega",
  },
  NZD: {
    en: "New Zealand dollar",
    es: "Dólar Neozelandés",
  },
  PEN: {
    en: "Peruvian sol",
    es: "Sol Peruano",
  },
  PHP: {
    en: "Philippine peso",
    es: "Peso Filipino",
  },
  PKR: {
    en: "Pakistani Rupee",
    es: "Rupia Pakistaní",
  },
  PLN: {
    en: "Polish złoty",
    es: "Zloty Polaco",
  },
  PYG: {
    en: "Paraguayan guarani",
    es: "Guaraní Paraguayo",
  },
  RON: {
    en: "Romanian leu",
    es: "Nuevo Leu Rumano",
  },
  RUB: {
    en: "Russian ruble",
    es: "Rublo Ruso",
  },
  RSD: {
    en: "Serbian Dinar",
    es: "Dinar Serbio",
  },
  UYU: {
    en: "Uruguayan peso",
    es: "Peso Uruguayo",
  },
  SAR: {
    en: "Saudi riyal",
    es: "Riyal Saudí",
  },
  SEK: {
    en: "Swedish krona",
    es: "Corona Sueca",
  },
  SGD: {
    en: "Singapore dollar",
    es: "Dólar de Singapur",
  },
  SRD: {
    en: "Surinamese dollar",
    es: "Dólar Surinamés",
  },
  THB: {
    en: "Thai baht",
    es: "Baht Tailandés",
  },
  TRY: {
    en: "Turkish lira",
    es: "Lira Turca",
  },
  TWD: {
    en: "New Taiwan dollar",
    es: "Nuevo dólar taiwanés",
  },
  UAH: {
    en: "Ukrainian hryvnia",
    es: "Grivna Ucraniana",
  },
  VEF: {
    en: "Venezuelan bolívar",
    es: "Bolívar Venezolano",
  },
  XAF: {
    en: "Central African CFA franc",
    es: "Franco CFA de África Central",
  },
  XOF: {
    en: "West African CFA franc",
    es: "Franco CFA de África Occidental",
  },
  ZAR: {
    en: "South African rand",
    es: "Rand Sudafricano",
  },
};
